/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useMemo } from "react";
import { db } from "~/db/db";

import prepareForOptions from "~services/utils/prepareForOptions";

const useTabelaSolicitacoesOptionsV2 = () => {
  const solicitacoes = useLiveQuery(() => db.tabelaSolicitacoes.toArray(), []);

  const optionSolicitacoes = useMemo(() => {
    if (!solicitacoes) return [];

    const uniqueSolicitacoes = [];
    const seen = new Set();

    solicitacoes.forEach((item) => {
      if (!seen.has(item.clienteId)) {
        seen.add(item.clienteId);
        uniqueSolicitacoes.push(item);
      }
    });

    return prepareForOptions(uniqueSolicitacoes, ["clienteLabel", ""], "clienteId");
  }, [solicitacoes]);

  return {
    optionSolicitacoes,
  };
};

export default useTabelaSolicitacoesOptionsV2;
